// import { get } from '@/axios'
import axios from 'axios'
import * as API from "../index";
const BASE_URL = window.location.origin+window.location.pathname;//process.env.BASE_URL;
// 获取组织机构根节点
// export const GET_DEPT_ROOT = () => get( BASE_URL + 'depRoot.json' )
export const GET_DEPT_ROOT = () => get( BASE_URL+'static/jsonData/depRoot.json' )
// export const GET_DEPT_ROOT = () => get( depRoot_URL )

// 根据部门id获取分页人员信息
export const GET_PAGE_EMPLOYEE = data => get(BASE_URL+'static/jsonData/userData.json', data )
// export const GET_PAGE_EMPLOYEE = data => get( userData_URL, data )

// 获取组织机构子节点
export const GET_DEPT_TREE = data => get(BASE_URL+'static/jsonData/depChild.json', data )
// export const GET_DEPT_TREE = data => get( depChild_URL, data )

// 获取组织机构下人员信息
export const GET_USER_BY_DEPT = data => get( BASE_URL+'static/jsonData/userData.json', data )
// export const GET_USER_BY_DEPT = data => get( userData_URL, data )
// 获取角色信息
export const GET_ROLE_DATA = () => get(BASE_URL+'static/jsonData/roleData.json')
// 获取Mock数据
// export const GET_MOCK_CONF = () => get('http://localhost:8080/static/jsonData/mockConf.json')
export const GET_MOCK_CONF = () => get(BASE_URL+'static/jsonData/initMockConf_test.json')
// export const GET_MOCK_CONF = () => get(mockConf_URL)


/*查询*/
export function queryApproval(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/page', params)
}

/*新增*/
export function addApproval(params) {
    return API.POST(COASERVER+'/api/v1/actExApproval/add', params)
}
/*修改*/
export function updateApproval(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/update', params)
}
/*删除*/
export function deleteApproval(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/del', params)
}
/*设置为主版本*/
export function setMajorV(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/major/version', params)
}
/*审批单部署*/
export function approvalDeploy(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/deploy', params)
}

/*模板上传接口*/
export function templateUpload(params) {
  return API.POST(COASERVER+'/api/v1/actExApproval/template/upload ', params)
}


export function get ( url, params ) {
  params = params || {}
  return new Promise( ( resolve, reject ) => {
    axios.get( url, {
        params: params
      } )
      .then( res => {
        resolve( res.data )
      } )
      .catch( err => {
        reject( err.data )
      } )
  } )
}



// WEBPACK FOOTER //
// ./src/api/xtbg_system/api_approverFlow.js